/* eslint-disable import/no-cycle */
import * as amplitude from '@amplitude/analytics-browser';

import { tripActions } from 'wanderu-ducks-trips';
import Logger from 'wanderu-logger';
import WapiService from 'wanderu-service-wapi';
import { isLandingPage } from 'wanderu-utils';

import { actions as psearchActions } from '../../appstate';
import {
    buildSearchBody,
    formatTripResults,
    serializeSearchParams,
} from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-psearch:fetchCachedTrips');

function fetch(opts, path = '') {
    return async (dispatch, getState) => {
        const working = selectors.selectWorking(getState(), opts);
        const success = selectors.selectSuccess(getState(), opts);
        if (working || success) {
            return;
        }

        dispatch(actions.startWork(opts));

        let error;
        let metaData;
        let tripIds = [];

        const defaultSearchParams = {
            cached: true,
            jitted: false,
            routed: false,
        };

        const searchParams = {
            ...defaultSearchParams,
            ...opts,
        };

        // prefers opts that may override default search params
        const body = buildSearchBody(searchParams);
        body.isSeoPage = isLandingPage(path);
        body.isWebApp = true;

        try {
            const {
                result,
                meta,
            } = await WapiService.post('psearch.json', { body });

            const trips = formatTripResults(result);

            dispatch(tripActions.setTrips(trips));

            const searchId = serializeSearchParams(opts);
            const { batchId } = body;
            tripIds = Object.keys(trips);

            const deviceId = amplitude.getDeviceId();
            const sessionId = amplitude.getSessionId();

            const context = {
                batchId,
                cachedTripCount: tripIds?.length,
                departDate: searchParams.departDatetime,
                destinationPlaceId: searchParams.destinationPlaceId,
                destinationText: searchParams.destinationText,
                deviceId,
                direction: searchParams.direction,
                originPlaceId: searchParams.originPlaceId,
                originText: searchParams.originText,
                returnDate: searchParams.returnDatetime,
                searchId,
                sessionId,
            };

            logger.event('fetch', context);

            dispatch(psearchActions.setSearchResults(
                searchId,
                batchId,
                tripIds,
                meta.trips,
            ));
        } catch (ex) {
            logger.error('fetch', ex, body);
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };

            throw ex;
        } finally {
            dispatch(actions.endWork(opts, metaData, error));

            const shouldRetryRouted = !tripIds.length && !searchParams.routed && searchParams.retryRouted;

            if (shouldRetryRouted) {
                dispatch(reset(searchParams));
                dispatch(fetch({
                    ...searchParams,
                    routed: true,
                }));
                // eslint-disable-next-line no-unsafe-finally
                return;
            }
        }
    };
}

function reset(opts) {
    return actions.reset(opts);
}

const fetchCachedTripsAction = {
    fetch,
    reset,
    ...selectors,
};

export {
    fetchCachedTripsAction,
};

export default {
    [namespace]: reducer,
};
